import React from 'react';

import GridContainer from 'components/atoms/Layout/Grid/GridContainer';
import GridItem from 'components/atoms/Layout/Grid/GridItem';
import Typography from 'components/atoms/Typography/Typography';
import InfoContainer from 'components/molecules/Common/InfoContainer/InfoContainer';
import { ThemeProvider } from '@material-ui/core/styles';

import { useTranslation } from 'react-i18next';
import { profileGeneralTheme } from 'themes';

export default function GeneralSection(props) {
  const { t } = useTranslation();

  const handleOpenPopup = (component) => {
    props.onTileClick && props.onTileClick(component);
  };

  return (
    <ThemeProvider theme={profileGeneralTheme}>
      <GridContainer>
        <GridContainer
          direction="row"
          style={{
            marginTop: '40px',
            marginBottom: '20px',
          }}
        >
          <GridItem
            style={{
              width: '50%',
              textAlign: 'left',
            }}
          >
            <Typography
              variant="h4"
              style={{
                textTransform: 'uppercase',
                fontSize: '15px',
              }}
            >
              {t('myProfile.subtitleGeneral')}
            </Typography>
          </GridItem>
        </GridContainer>
        <GridContainer direction="column" style={{ textAlign: 'left' }}>
          <InfoContainer
            title={t('myProfile.zipCode')}
            value={props.zipCode && props.zipCode}
            color="primary"
            tallContainer={true}
            onTileClick={() => handleOpenPopup('zipCode')}
          />
        </GridContainer>
      </GridContainer>
    </ThemeProvider>
  );
}
